import React from 'react';
import { styled as styled2 } from '@compiled/react';
import Heading from '@atlaskit/heading';
import { token } from '@atlaskit/tokens';

// Duplicated to avoid cyclic issues in the build, this file will be fully removed when cleaning replace-typography-css-with-tokens-for-chronos
const DEFAULT_CONTENT_WIDTH = 500;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ContentLegacy = styled2.div({
	display: 'flex',

	width: `${DEFAULT_CONTENT_WIDTH}px`,
	flexDirection: 'column',
	justifyContent: 'flex-start',
	alignItems: 'center',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const MessagesLegacy = styled2.div({
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
	fontSize: '15px',
	textAlign: 'center',
	marginTop: token('space.250', '20px'),
	marginBottom: token('space.250', '20px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const TitleComponentLegacy = styled2.div({
	marginTop: token('space.500', '40px'),
	textAlign: 'center',
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const TitleLegacy = (props: any) => (
	<Heading size="large">
		<TitleComponentLegacy {...props} />
	</Heading>
);

// Remove the whole file when cleaning up replace-typography-css-with-tokens-for-chronos
